import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { createInertiaApp } from '@inertiajs/vue2'
import { VueMaskDirective } from 'v-mask'

import { ZiggyVue } from 'ziggy'
import { Ziggy } from './ziggy'
import VModal from 'vue-js-modal'

Vue.config.productionTip = false
Vue.mixin({
    methods: {
        route: window.route,
    },
})
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(ZiggyVue, Ziggy)
Vue.use(VModal)

Vue.directive('mask', VueMaskDirective)

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup ({ el, App, props, plugin }) {
        Vue.use(plugin)

        new Vue({
            metaInfo: {
                titleTemplate: title => (title ? `${title} - SAPBKPP` : 'SAPBKPP'),
            },
            render: h => h(App, props),
        }).$mount(el)
    },
})
